import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { getInvitePreview, acceptInvite } from '../api';
import { setActiveOrg } from '../org';
import AuthLayout, { Alert, primaryBtnClass } from '../components/AuthLayout';

function AcceptInvite() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const navigate = useNavigate();
  const signedIn = !!localStorage.getItem('admin_token');
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setError('Missing invite token'); setLoading(false); return; }
    getInvitePreview(token).then((r) => setPreview(r.data))
      .catch((e) => setError(e.response?.data?.detail || 'Invite not found or expired'))
      .finally(() => setLoading(false));
  }, [token]);

  const accept = async () => {
    setBusy(true); setError('');
    try {
      const r = await acceptInvite(token);
      if (r.data?.org_id) setActiveOrg(r.data.org_id, preview?.org_name);
      navigate('/dashboard', { replace: true });
    } catch (e) { setError(e.response?.data?.detail || 'Could not accept'); setBusy(false); }
  };

  return (
    <AuthLayout title="You've been invited" subtitle={preview ? `Join ${preview.org_name}` : 'Organization invite'}>
      {loading ? <p className="text-fg-muted text-sm">Loading invite…</p> : error ? <Alert>{error}</Alert> : (
        <>
          <div className="mb-6 p-4 rounded-lg bg-panel border border-panel-border text-sm">
            <p className="text-fg">Organization: <strong>{preview.org_name}</strong></p>
            <p className="text-fg-muted mt-1">Role: {preview.role}</p>
          </div>
          {signedIn ? (
            <button onClick={accept} disabled={busy} className={primaryBtnClass}>{busy ? 'Joining…' : `Join ${preview.org_name}`}</button>
          ) : (
            <div className="space-y-2 text-sm text-center">
              <Link to={`/signup?invite=${token}`} className={primaryBtnClass + ' block text-center'}>Create an account to join</Link>
              <p className="text-fg-muted">Already have an account? <Link to="/login" className="text-orange hover:underline">Sign in</Link>, then reopen this link.</p>
            </div>
          )}
        </>
      )}
    </AuthLayout>
  );
}

export default AcceptInvite;
